<form (ngSubmit)="save()" novalidate>
  <h3>{{ 'laskuasetukset.laskuttaja' | translate | async }}</h3>
  <div class="asetusruudukko">
    <mat-form-field>
      <mat-label>{{ 'laskuasetukset.yrityksen-nimi' | translate | async }}</mat-label>
      <input #nimiInput type="text" [formField]="lomake.nimi" matInput />
      <mat-error>{{ fieldErrors().nimi }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'laskuasetukset.y-tunnus' | translate | async }}</mat-label>
      <input type="text" [formField]="lomake.ytunnus" matInput />
      <mat-error>{{ fieldErrors().ytunnus }}</mat-error>
    </mat-form-field>
    <mat-form-field class="leveä">
      <mat-label>{{ 'laskuasetukset.katuosoite' | translate | async }}</mat-label>
      <input type="text" [formField]="lomake.katuosoite" matInput />
      <mat-error>{{ fieldErrors().katuosoite }}</mat-error>
    </mat-form-field>
    <div class="postiosoite">
      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.postinro' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.postinro" matInput />
        <mat-error>{{ fieldErrors().postinro }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'laskuasetukset.postitoimipaikka' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.postitoimipaikka" matInput />
        <mat-error>{{ fieldErrors().postitoimipaikka }}</mat-error>
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>{{ 'laskuasetukset.maa' | translate | async }}</mat-label>
      <mat-select [formField]="lomake.maa">
        @for (maa of maat | async; track maa) {
          <mat-option [value]="maa.koodi">
            {{ maa.nimi }}
          </mat-option>
        }
      </mat-select>
      <mat-error>{{ fieldErrors().maa }}</mat-error>
    </mat-form-field>
  </div>

  <h3>{{ 'laskuasetukset.asiakaspalvelun-yhteystiedot-laskulla' | translate | async }}</h3>
  <div class="asetusruudukko">
    <mat-form-field>
      <mat-label>{{ 'laskuasetukset.sahkoposti' | translate | async }}</mat-label>
      <input type="email" [formField]="lomake.aspaemail" matInput />
      <mat-error>{{ fieldErrors().aspaemail }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'laskuasetukset.puhelinnumero' | translate | async }}</mat-label>
      <input type="tel" [formField]="lomake.aspapuh" matInput placeholder="+358" />
      <mat-error>{{ fieldErrors().aspapuh }}</mat-error>
    </mat-form-field>
  </div>

  <div class="asetusnappulat">
    <button class="primarybutton" mat-button (click)="save()" type="button">{{ 'yleiset.tallenna' | translate | async }}</button>
  </div>
</form>
